module.exports = __webpack_public_path__ + "static/bg-shipping-1-be53f0c0b0d131fa4e277449d7926432.jpg";